import SeasonMapper from './season-mapper';
import SeasonModelBase from '../../agent/season/season-model';

const SeasonModel = {
    ...SeasonModelBase,

    mapper: SeasonMapper,

    categoryId: {
        fieldName: 'c',
        type: String,
    },

    currentSeasonId: {
        fieldName: 'r',
        type: String,
    },

    names: {
        fieldName: 'n',
        type: Object,
    },
};

export default SeasonModel;
